import { Line, LineChart, ResponsiveContainer } from "recharts";

interface SparklineProps {
  data: number[];
  color?: string;
  height?: number;
}

export function Sparkline({ data, color = "var(--chart-1)", height = 32 }: SparklineProps) {
  if (data.length === 0) {
    return <div className="h-8 w-24 bg-muted/40 rounded" aria-hidden />;
  }
  const chartData = data.map((value, idx) => ({ idx, value }));
  return (
    <div className="w-24" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData} margin={{ top: 2, right: 2, bottom: 2, left: 2 }}>
          <Line
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
